import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Media = () => {
  const [mediaFiles, setMediaFiles] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    id: null
  });

  const server = process.env.REACT_APP_API_URL;

  const fileInputRef = useRef(null);
  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async () => {
    try {
      const res = await axios.get(`${server}api/media/media`);
      const normalized = res?.data?.media?.map((m) => {
        const url = m.mediaFile.startsWith("http") ? m.mediaFile : `${server}/${m.mediaFile}`;
        return {
          ...m,
          mediaFile: url,
          type: /\.(jpg|jpeg|png|gif|webp)$/i.test(url)
            ? "image"
            : /\.(mp4|mov|avi|webm)$/i.test(url)
            ? "video"
            : "unknown"
        };
      });
      setMediaFiles(normalized);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Select a file!");

    setLoading(true);
    const formData = new FormData();
    formData.append("mediaFile", file);

    try {
      await axios.post(`${server}api/media/media`, formData);
      toast.success("Uploaded!");
      console.log('file-->',setFile)
      setFile(null);
        fileInputRef.current.value = ""; // ✅ This clears UI file name
      fetchMedia();
    } catch (err) {
      toast.error("Upload failed!");
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (id) => {
    setDeleteConfirmation({ open: true, id });
  };

const handleConfirmDelete = async () => {
  const { id } = deleteConfirmation;
  try {
    await axios.delete(`${server}api/media/media/${id}`);

    // ✅ FIXED UI UPDATE
    setMediaFiles((prev) => prev.filter((m) => m._id !== id));

    toast.success("Deleted Successfully");
  } catch (err) {
    toast.error("Delete failed");
  }
  setDeleteConfirmation({ open: false, id: null });
};


  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Select file to update");

    setLoading(true);
    const formData = new FormData();
    formData.append("mediaFile", file);

    try {
      await axios.put(`${server}api/media/media/${selectedMedia}`, formData);
      toast.success("Updated Successfully");
      setSelectedMedia(null);
      setFile(null);
      fetchMedia();
    } catch (err) {
      toast.error("Update Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <ToastContainer />

      <h1 className="text-3xl font-bold mb-6">📸 Media Management</h1>

      {/* Upload */}
      <div className="bg-white p-6 rounded shadow mb-8">
        <form onSubmit={handleUpload} className="flex items-center gap-4">
          <input type="file" accept="image/*,video/*" onChange={handleFileChange}  ref={fileInputRef}/>
          <button className="bg-blue-600 text-white px-4 py-2 rounded" disabled={loading}>
            {loading ? "Uploading..." : "Upload"}
          </button>
        </form>
      </div>

      {/* Media Grid */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {mediaFiles.map((media) => (
          <div key={media.id} className="bg-white rounded shadow">
            <div className="h-48 overflow-hidden">
              {media.type === "image" && <img src={media.mediaFile} className="w-full h-full object-fill" />}
              {media.type === "video" && <video controls src={media.mediaFile} className="w-full h-full object-cover" />}
            </div>

            <div className="flex justify-between p-3">
              <button className="bg-yellow-500 px-3 py-1 rounded text-white" onClick={() => setSelectedMedia(media)}>
                Edit
              </button>
              <button className="bg-red-600 px-3 py-1 rounded text-white" onClick={() => confirmDelete(media?._id)}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirmation.open && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow">
            <p className="mb-4">Are you sure you want to delete?</p>
            <div className="flex justify-end gap-3">
              <button className="bg-gray-300 px-4 py-1 rounded" onClick={() => setDeleteConfirmation({ open: false })}>
                Cancel
              </button>
              <button className="bg-red-600 text-white px-4 py-1 rounded" onClick={handleConfirmDelete}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Update Modal */}
      {selectedMedia && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white p-6 rounded">
            <form onSubmit={handleUpdate}>
              <input type="file" accept="image/*,video/*" onChange={handleFileChange} />
              <div className="flex justify-end gap-3 mt-3">
                <button onClick={() => setSelectedMedia(null)} className="px-4 py-1 bg-gray-300 rounded">
                  Cancel
                </button>
                <button className="px-4 py-1 bg-yellow-500 text-white rounded" disabled={loading}>
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Media;
